const routerPC = [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/home',
      name: '天科首页',
      component: () => import('../views/HomeView'),
      meta: {
        active: '天科首页',
      }
    },
    {
      path: '/company',
      name: '公司简介',
      component:() => import('../views/CompanyView'),
      meta: {
        active: '公司简介',
        navShow: true
      }
    },
    {
      path: '/product',
      name: '产品展示',
      component:() => import('../views/ProductView'),
      children: [
        {
          path: '/product/pcb',
          name: '线路板产品',
          component: () => import('../views/pcbView'),
          meta: {
            active: '线路板产品',
            navShow: true
          }
        },
        {
          path: '/product/NE',
          name: '新能源产品',
          component:() => import('../views/neView'),
          meta: {
            active: '新能源产品',
            navShow: true
          }
        },
      ],
      meta: {
        active: '产品展示',
        navShow: true
      },
    },
    {
      path: '/serve',
      name: '产品服务',
      component: () => import('../views/ServeView'),
      meta: {
        active: '产品服务',
        navShow: true
      }
    },
    {
      path: '/serve/detail',
      name: '产品服务',
      component: () => import('../views/ServeDetail'),
      meta: {
        active: '产品服务',
        navShow: true
      }
    },
    {
      path: '/credit',
      name: '证书资质',
      component:() => import('../views/CreditView'),
      meta: {
        active: '证书资质',
        navShow: true
      }
    },
    {
      path: '/news',
      name: '新闻中心',
      component:() => import('../views/NewsList'),
      meta: {
        active: '新闻中心',
        navShow: true
      }
    },
    {
      path: '/cooperate',
      name: '合作伙伴',
      component:() => import('../views/CooperateView'),
      meta: {
        active: '合作伙伴',
        navShow: true
      }
    },
    {
      path: '/connect',
      name: '联系我们',
      component:() => import('../views/ConnectView'),
      meta: {
        active: '联系我们',
        navShow: true
      }
    },
    {
      path: '/detail',
      name: '产品详情',
      component: () => import('../views/PcbDetail'),
      meta: {
        active: '产品详情',
        navShow: true
      }
    },
    {
      path: '/news/detail',
      name: '新闻中心',
      component: () => import('../views/NewsDetail'),
      meta: {
        active: '新闻中心',
        navShow: true
      }
    }
  ]
  
  export default routerPC
  